import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=f240df1a&lang=pug&"
import script from "./SendEmail.vue?vue&type=script&lang=ts&"
export * from "./SendEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports